<template>
    <main-layout >
        <img src="@/assets/img/sideText.png" class="sideText"/>
       
        <div class="has-text-dark isPoppins homePage">
            

           <!-- HERO -->
    <div class="mainHeroContainer skewYneg">
         <div class=" topHomeDiv mainHero posRel skewYpos">
           
                   <div class="container top-120 has-text-white absCenter topDiv" >
                       
                       <div class="columns   is-vcentered " >
                            <div class="column is-two-fifths">
                                <div class="is-size-1 smart">
                                    <b>Smart Links<br>Everyone will Remember</b>
                                </div>
                                <div class="top10">
                                    <span class="is-size-4">Call your audience to action effectively</span> 
                                   <!--  <div class="is-size-5 top20" >Transform your clunky URLs into memorable natural language <b>smart links:</b> <b class="has-text-sBlue">slinks</b></div >   -->
                                </div>
                    
                            </div>
                
                            
                            <div class="column has-text-centered " data-aos="slide-right">
                                <div><get-started  ref="gs"></get-started></div>
                            </div>
                       </div>
        
                      <div class="top30">
                         
                               <div class="slider">
                                    <div class="top20 has-text-left">
                                        <div class="is-size-4 is-inline-block has-text-white"><b>Share your</b></div>
                                        <div  class="sliderBG is-inline-block">
                                            <div class="posRel topAdjust">
                                                <div data-delay="1200" id="dataWords" class="">
                                                    
                                                    <span class="text-anim-items">
                                                        <span class="text-anim-item"><span>Meeting ID</span></span>
                                                        <span class="text-anim-item"><span>Webpage</span></span>
                                                        <span class="text-anim-item"><span>Social Profile</span></span>
                                                        <span class="text-anim-item"><span>Payment Page</span></span>
                                                        <span class="text-anim-item"><span>Online Storage</span></span>
                                                        <span class="text-anim-item"><span>Affiliate Link</span></span>
                                                        <span class="text-anim-item"><span>Landing Page</span></span>
                                                        <span class="text-anim-item"><span>Email</span></span>
                                                        <span class="text-anim-item"><span>Phone Number</span></span>
                                                        <span class="text-anim-item"><span>Photo Album</span></span>
                                                        <span class="text-anim-item"><span>Music Playlist</span></span>
                                                        <span class="text-anim-item"><span>Post</span></span>
                                                        <span class="text-anim-item"><span>Location</span></span>
                                                    </span>
                                                    <span class="anim-line"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class=" is-size-4 has-text-white has-text-left  mobileTop5"><b>with an easy to say <span class="has-text-yell has-text-weight-normal">|</span> easy to remember <span class="is-size-3"><span class="has-text-white">s</span ><span class="has-text-weight-normal">mart</span > <span class="has-text-white">link</span ></span ></b></div>
                               </div>
    
                               <div class="top30 ">
                                    <button class="button is-yell top1 has-text-primary left-5" @click="goToHow"><b>LEARN MORE</b></button>
                                </div>

                               <div class="has-text-left"> <img src="@/assets/img/chevronTdown.png"  @click="goToHow" class="chevDown handCursor" width="30" /></div>

                                <div class="is-hidden-desktop">
                                    <br><br><br><br>
                                </div>
                      </div>
                   </div>
         </div >
    </div>



           <!-- HOW IT WORKS -->
           
          <div class="howWorksBG  skewYneg" >

                  <div class="howWorksMid skewYpos">
                        <div class="has-text-white has-text-left howWorks container" ref="how">
                            
                            
                            <div class="">
        
                                <div class="is-size-2 has-text-yell top80"><img src="@/assets/img/chevronsT.png" width="30" /><b class="left3">How it Works</b></div>
                                <div class="columns is-vcentered top20 left20">
                                   <div class="column is-three-fifths" data-aos="fade-right">
                                       
                                        <div class="lgRoundTopRight verticalsContent">
                                            <div class="vAlignTop is-size-2 has-text-turk"><b>1.</b>&nbsp;<b class="is-size-3 has-text-yell">Create your slink: &nbsp;</b></div>
                                           
                                            <br>
                                            <div class="addSubs is-inline-block">
                                                <div class="is-size-4 is-inline-block"><b>turn:</b> <span class="has-text-grey-light">https://www.clothes-website.com?aff=xdd345</span ></div>
                                                <div class="top5"><b class="is-size-4">into: &nbsp;</b><span class="has-text-turk is-size-3">slink.com/</span><span class="has-text-yell is-size-3">fashion</span ><!-- &nbsp;&nbsp;&nbsp;<i class="fa fa-reply-all verticalFlip is-size-3 has-text-turk"></i> --></div>
                                            </div>
                                            <div class="is-size-4 top20 howEach has-text-white">
                                                You retain exclusive control over each slink word you reserve
                                            </div>
                                        </div>
                                        <br>
                                        <div class="top40 verticalsContent lgRoundBottomRight">
                                            <div class="is-size-2 has-text-turk"><b>2.</b>&nbsp;<b class="is-size-3 has-text-yell">Add Subslinks: &nbsp;</b></div>
                                           
                                            <div class=" top5 is-vcentered">
                                                <br>
                                                    <div class="is-inline-block has-text-left   addSubs">
                                                        <div class=""><span class="has-text-turk is-size-4">slink.com/</span><span class="has-text-yell is-size-4">fashion<span class="has-text-white"><b class="has-text-turk">:</b></span><b>sale</b></span ></div>
                                                        <div class="top5"><span class="turkLightText is-size-4">slink.com/</span><span class="has-text-yell is-size-4">fashion<span class="has-text-white"><b class="has-text-turk">:</b></span><b>shoes</b></span ></div>
                                                        <div class="top5"><span class="turkLightText2 is-size-4">slink.com/</span><span class="has-text-yell is-size-4">fashion<span class="has-text-white"><b class="has-text-turk">:</b></span><b>men</b></span ></div>
                                                        <div class="top5"><span class="turkLightText3 is-size-4">slink.com/</span><span class="has-text-yell is-size-4">fashion<span class="has-text-white"><b class="has-text-turk">:</b></span><b>deals</b></span ></div>
                                                        <div class="top5"><span class="turkLightText4 is-size-4">slink.com/</span><span class="has-text-yell is-size-4">fashion<span class="has-text-white"><b class="has-text-turk">:</b></span><b>trends</b></span ></div>
            
                                                      
                                                    </div>
                                                    <div class="is-size-4 top20 howEach has-text-white">
                                                            Point each subslink to a different URL.<br> Anything that has a URL can be <b class="has-text-turk">slinked</b>.
                                                    </div>
                                            </div>
                                        </div>
                                        
                                   </div>
                                   <div class="column has-text-white is-size-4" data-aos="fade-down">
                                        <div class="checkMarks">
                                            <div><i class="fa fa-check top10 has-text-yell right5"></i> Easy Recall</div>
                                            <div><i class="fa fa-check top10 has-text-yell right5"></i> Analytics</div>
                                            <div><i class="fa fa-check top10 has-text-yell right5"></i> Organization</div>
                                            <div><i class="fa fa-check top10 has-text-yell right5"></i> Simplification</div>
                                            <div><i class="fa fa-check top10 has-text-yell right5"></i> Branding</div>
                                            <!-- <div><i class="fa fa-check-square top10 has-text-turk"></i> SlinkPage</div> -->
                                        </div>
                                   </div>
                                </div>
                                <div class="top40" data-aos="fade-left">
                                    <div class="dot">&nbsp;</div>
                                    <div class="dot">&nbsp;</div>
                                    <div class="dot">&nbsp;</div>
                                    <div class="dot">&nbsp;</div>
                                </div>
                            </div>
                        </div>

                        <div class="iconsDiv container ">
                
                <div class="has-text-grey-light is-size-4"><b>Used on every major podcasting and social platform:</b></div>
               <div class="is-size-7">
                    <div class="is-inline-block has-text-centered">
                        <div><img src="@/assets/img/googlePodcasts.png" width="100" class="marginAutod" /></div>
                        <div class="has-text-grey">Google Podcasts</div>
                    </div>
                    <div class="is-inline-block  has-text-centered">
                        <img  src="@/assets/img/spotify.png"/>
                        <div class="has-text-grey">Spotify</div>
                    </div>
                    <div class="is-inline-block  has-text-centered">
                        <img src="@/assets/img/applePodcasts.png"/>
                        <div class="has-text-grey">Apple Podcasts</div>
                    </div>
                   
                    <div class="is-inline-block has-text-centered left5">
                    <div> <img src="@/assets/img/overcast.png" /></div>
                     <div class="has-text-grey">Overcast</div>
                    </div>

                    <div class="is-inline-block has-text-centered">
                    <div> <img src="@/assets/img/tiktok.png" /></div>
                     <div class="has-text-grey">Tiktok</div>
                    </div>

                    <div class="is-inline-block has-text-centered">
                    <div> <img src="@/assets/img/insta.png" /></div>
                     <div class="has-text-grey">Instagram</div>
                    </div>

                    <div class="is-inline-block has-text-centered">
                    <div> <img src="@/assets/img/youtube.png" /></div>
                     <div class="has-text-grey">YouTube</div>
                    </div>

                    <div class="is-inline-block has-text-centered">
                    <div> <img src="@/assets/img/linkedin.png" /></div>
                     <div class="has-text-grey">LinkedIn</div>
                    </div>

                    <div class="is-inline-block has-text-centered">
                    <div> <img src="@/assets/img/twitter.png" /></div>
                     <div class="has-text-grey">Twitter</div>
                    </div>
               </div>
           </div>
                  </div>
               
          </div>

           <!-- VERTICALS -->
           <div class="slantedDiv verticals ">
               <div class="container has-text-white">
                <div class="is-size-2 has-text-white has-text-left isPoppins"><img src="@/assets/img/chevronsY.png" width="30" /><b class="left3">Why use Slinks?</b></div>
                  <div class="verticalsContentMain top40" data-aos="fade-left">
                        <div class="columns top20">
                            <div class="column verticalsColumn">
                                <div class="is-size-3 vertTitle">
                                    <b>Podcasts, Audio Ads, Influencers & OOH</b>
                                </div>
                                <ul class="top40 left20 is-size-5  panelText has-text-light">
                                    <li>Overcome the difficulties in relaying an effective verbal or printed call to action</li>
                                    <li class="top20">Track your verbal and printed calls to action with the same level analytics that click ads generate</li>
                                    <li class="top20">Simplify affiliate links into logical, easy to remember urls</li>
                                    <li class="top20">Leverage the SlinkPage to direct your audience to a listing of all your subslinks</li>
                                    <li class="top20">Organize your calls to action into branded groups under your slink using subslinks:</li>
                                </ul>
                                <div class="top30 left20 is-size-5 egs">
                                    <span class="has-text-yell"><b>Eg:</b></span> <b>gourmetshow</b>
                                    <ul class="top5" >
                                        <li><span class="has-text-grey-light">gourmetshow</span><b>:recipes</b></li>
                                        <li><span class="has-text-grey-light">gourmetshow</span><b>:episodes</b></li>
                                        <li><span class="has-text-grey-light">gourmetshow</span><b>:episode11</b></li>
                                        <li><span class="has-text-grey-light">gourmetshow</span><b>:discounts</b></li>
                                        <li><span class="has-text-grey-light">gourmetshow</span><b>:courses</b></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="column verticalsColumn">
                                <div class="is-size-3 vertTitle">
                                    <b>Brands & Agencies</b>
                                </div>
                                <ul class="top40 left20 is-size-5    panelText has-text-light">
                                    <li>Leverage the benefits of controlling a category-defining word such as "music" or "fashion" and/or...</li>
                                    <li class="top20">...Strengthen the power and recall of your brand by using it as the root for all your subslinks</li>
                                    <li class="top20">Increase engagement by providing a friction-free, traffic enabler to your content</li>
                                    <li class="top20">Consolidate analytics acrosss multiple media and run AB tests using different slinks or subslinks</li>
                                    <li class="top20">Create directories of related links under a slink using subslinks:</li>
                                </ul>
                                <div class="top20 left20 is-size-5  egs">
                                    <span class="has-text-yell"><b>Eg:</b></span> <b>fashion</b>
                                    <ul class="top5">
                                        <li><span class="has-text-grey-light">fashion</span><b>:sale</b></li>
                                        <li><span class="has-text-grey-light">fashion</span><b>:shoes</b></li>
                                        <li><span class="has-text-grey-light">fashion</span><b>:men</b></li>
                                        <li><span class="has-text-grey-light">fashion</span><b>:discounts</b></li>
                                        <li><span class="has-text-grey-light">fashion</span><b>:trends</b></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="column verticalsColumn" >
                                <div class="is-size-3 vertTitle">
                                    <b>Personal use</b>
                                </div>
                                <ul class="top40 left20 is-size-5   panelText has-text-light  ">
                                    <li>Virtually eliminate the typical obstacles in verbally relaying personal URLs like your email, a meeting ID, a payment page. Even turn your phone number into a slink</li>
                                    <li class="top20">Make it easy for people to remember how to reach you without having to look up your info</li>
                                    <li class="top20">Set up personal shortcuts for things like online storage folders, family photo albums, travel itineraries, food order lines, etc, so they can easily be reached from memory and from any device</li>
                                    <li class="top20">Consolidate all your contact links under your slink using subslinks:</li>   
                                </ul>
                                <div class="top20 left20 is-size-5  egs">
                                    <span class="has-text-yell"><b>Eg:</b></span> <b>john</b>
                                    <ul class="top5">
                                        <li><span class="has-text-grey-light">john</span><b>:zoom</b></li>
                                        <li><span class="has-text-grey-light">john</span><b>:email</b></li>
                                        <li><span class="has-text-grey-light">john</span><b>:phone</b></li>
                                        <li><span class="has-text-grey-light">john</span><b>:calendar</b></li>
                                        <li><span class="has-text-grey-light">john</span><b>:instagram</b></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                  </div>
                  <div class="has-text-left"> <img src="@/assets/img/chevronTdown.png" class="chevDown" width="30" /></div>
                  <div class="top20 is-pulled-right">
                    <div class="dot">&nbsp;</div>
                    <div class="dot">&nbsp;</div>
                    <div class="dot">&nbsp;</div>
                    <div class="dot">&nbsp;</div>
                 </div>
               </div>
               
               <br><br><br><br>
           </div>

           <!-- QUOTE 1-->
           <div class="has-text-centered quote1 ">
                <div class="columns top60">
                    <div class="column is-size-3 container is-hidden-mobile">&nbsp;</div>
                    <div class="column is-size-3 container is-two-thirds has-text-right">"Slinks are like vanity 1-800 numbers for the Internet, like QR codes that can be remembered, like a search term that points to only one result, <b>yours</b>"</div>
                    
                </div>
           </div>

           <!-- PANEL 1 -->
           <div class="thePanels ">
               <div class="">
                
                    <div class="columns">
                        <div class="column has-text-dark has-text-white is-four-fifths" data-aos="slide-right">
                           
                           <div class="columns ">
                                <div class="column panelImg is-three-fifths">
                                    <img src="@/assets/img/listener.png" class="is-pulled-right" />
                                </div>
                                <div class="column">
                                    <div class="panelCol pullRight top-20" >
                                        <br><br><br><br>
                                        <div><i class="fa fa-check has-text-yell" style="font-size: 120px"></i></div>
                                        <div class="is-size-3 top10"><b>Bridge the gap between the physical and digital marketing worlds</b></div>
                                        <div class="top40 panelText">
                                            <ul class="top40 is-size-4 ">
                                                <li>Slinks are just as effective when relayed <b class="has-text-turk">verbally, in print or as clickable links</b></li>
                                                <li class="top20">Get the <b class="has-text-turk">same level of analytics</b> from verbal or printed calls to action as are available from "click ads"</li>
                                                <li class="top20">Consolidate campaigns <b class="has-text-turk">across different media</b></li>
                                                <li class="top20">Perform <b class="has-text-turk">AB testing</b> using different slinks or subslinks</li>                     
                                            </ul>
                                        </div>
                                    </div >
                               </div>
                           </div>
                        </div>
                        <div class="column transBG is-hidden-mobile">
                           
                        </div>
                    </div>
               </div>
    
                 <!-- PANEL 2 -->
                 <!-- <div class="top10 container">
                    <div class="columns top160 ">
                        <div class="column">
                            <img  src="@/assets/img/ownyourwordsyellow.png" width="230" class="top10   "/>
                        </div>
                        <div class="column  has-text-black is-four-fifths">
                                <div class="is-size-3 has-text-primary"><b>Confusion is a conversion killer</b></div>
                                <div class="top40">
                                    <ul class="top40 panelText is-size-4 ulDisc">
                                        <li>Using a <b class="has-text-mag">simple, descriptive word</b> as the means through which users can access your content provides the path of least resistance to it</li>
                                        <li class="top20">Having your content be <b class="has-text-mag">exclusively associated with a category-defining word</b> such as "cars" or "music" lends instant credibility and top-of-mind advantage</li>    
                                        <li class="top20">Simplify your URLs, <b class="has-text-mag">such as affiliate links, online meeting id links and payment pages</b></li>     
                                        <li class="top20">There is power in words. <b class="has-text-mag">Take control of yours</b> to deliver ROI</li>                                   
                                    </ul>
                                </div>
                        </div>
                    </div>
               </div> -->

               <div class="top10">
                    <div class="columns">
                        <div class="column is-hidden-mobile transBG ">
                            &nbsp;
                        </div>
                        <div class="column panelTrans has-text-white is-four-fifths  " data-aos="slide-left">
                            <div class="columns">
                               
                                <div class="column is-two-fifths">
                                        <div class="panelCol pullRight has-text-right" >
                                            <br><br><br><br>
            
                                            <img  src="@/assets/img/ownyourwordsyellow.png" width="130"/>
                                            <div class=" top40">
                                                <div class="is-size-3 "><b>Confusion is a conversion killer</b></div>
                                                <div class="top40 is-size-4">
                                                    <ul class="top40 panelText ">
                                                        <li>Using a <b class="has-text-yell">simple, descriptive word</b> as the means through which users can access your content provides the path of least resistance to it</li>
                                                    <li class="top20">Having your content be <b class="has-text-yell">exclusively associated with a category-defining word</b> such as "cars" or "music" lends instant credibility and top-of-mind advantage</li>    
                                                    <li class="top30">Simplify your URLs, <b class="has-text-yell">such as affiliate links, online meeting id links and payment pages</b></li>     
                                                   <!--  <li class="top20">There is power in words. <b class="has-text-yell">Take control of yours</b> to deliver ROI</li>      -->
                                                    </ul>
                                                </div>
                                        </div>
                                        
                                        </div>
                                </div>

                                <div class="column panelImg2  ">
                                    <img src="@/assets/img/bulb.png" class="is-pulled-left " />
                                </div>
                            </div>
                        </div>
                      
                    </div>
               </div>
    
                <!-- PANEL 3 -->
                <div class="top10">
                    <div class="columns">
                        <div class="column  has-text-dark is-four-fifths " data-aos="slide-right">
                            <div class="columns">
                                <div class="column panelImg   is-three-fifths">
                                    <img src="@/assets/img/embed.png" class="is-pulled-right  " />
                                </div>
                                 <div class="column">
                                    <div class="panelCol pullRight" >
                                        <br><br><br><br>

                                        <img src="@/assets/img/chevronsY.png" width="160"/>
                                        <div class=" top40">
                                            <div class="is-size-3 "><b>Embed your links into your audience’s memory</b></div>
                                            <div class="top40 is-size-4">
                                                <ul class="top40 panelText ">
                                                    <li>The more memorable your call to action, <b class="has-text-turk">the higher your chances of conversion</b></li>
                                                    <li class="top20">Slinks remain in people's memory long after they see or hear them, <b class="has-text-turk">increasing the likelihood that they will be able to find your content over and over again,</b>  without the need for a clickable link or a QR code in front of them</li>                    
                                                </ul>
                                            </div>
                                    </div>
                                    
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="column is-hidden-mobile transBG">
                            &nbsp;
                        </div>
                    </div>
               </div>
               
           </div>

            <!-- QUOTE 2-->
            <div class="has-text-left quote1">
                <div class="is-size-3 container zQuote">Increase your connectivity and availability with <b>slinks</b> and <b>subslinks</b></div>
                <br> <br><br>
            </div>

          
            <div class="slantedDivMain has-background-textGrey">
                <div class="container">

              <!-- WHAT YOU GET -->
                    <div class="whatYouGet mobileMargin">
                        <div class="is-size-2 has-text-white has-text-centered"><img src="@/assets/img/chevronsY.png" width="30" /><b class="left3">What you Get</b></div>
                        <div class="has-text-white is-size-5 wideLimitWidth marginAutod top60">
                            <div class="">
                                <div class="top20"><span class="has-text-yell"><div class="is-inline-block vAlignTop is-size-4 has-text-yell"><b>1.</b>&nbsp;</div> </span>A <b>slink</b> made up of a strong, descriptive word related to your brand, product or industry.</div>
                                <div class="top20"><span class="has-text-yell"><div class="is-inline-block vAlignTop is-size-4 has-text-yell"><b>2.</b>&nbsp;</div></span><b>Subslinks</b> to add and organize additional smart links under your slink, streamlining your audience's access to your content</div>
                            </div>
                            <div class="">
                                <div class="top20"><span class="has-text-yell"><div class="is-inline-block vAlignTop is-size-4 has-text-yell"><b>3.</b>&nbsp;</div> </span>A <b>SlinkPage</b> for each slink, where you can list all your slink's subslinks:</div>
                                <div class="linksSubsContainer top20"  data-aos="zoom-in-up">
                                    <div class="top20 lpSub main home">
                                        <div class="columns lpCols">
                                            <div class="is-inline-block isPoppins is-size-4 column is-one-third"><img src="@/assets/img/chevronsY.png" width="18"/><b class="left3">hits</b></div>
                                            <div class="is-size-5 column">
                                                <div class="lpDescHome">Music promotion services - website</div>
                                            </div>
                                        </div>
                                        <div class="is-size-6 left10">slink.com/<b>hits</b></div>
                                    </div>

                                    <div class="left20 top15 lpSub">
                                        <div class="columns lpCols">
                                            <div class="isPoppins is-size-4 column is-one-third">&nbsp;<b>:calendar</b></div>
                                            <div class="is-size-5 column">
                                                <div class="lpDescHome">Schedule a meeting with us</div>
                                            </div>
                                        </div>
                                        <div class="is-size-6 left10">slink.com/hits<b>:calendar</b></div>
                                    </div>

                                    <div class="left20 top15 lpSub">
                                        <div class="columns lpCols">
                                            <div class="isPoppins is-size-4  column is-one-third">&nbsp;<b>:music</b></div>
                                            <div class="is-size-5  column">
                                                <div class="lpDescHome is-size-5"  column>Our catalog of releases</div>
                                            </div>
                                        </div>
                                        <div class="is-size-6 left10">slink.com/hits<b>:music</b></div>
                                    </div>
                                    
                                    <div class="left20 top15 lpSub">
                                        <div class="columns lpCols">
                                            <div class="isPoppins is-size-4  column is-one-third">&nbsp;<b>:email</b></div>
                                            <div class="is-size-5  column">
                                                <div class="lpDescHome is-size-5"  column>Email us for more information</div>
                                            </div>
                                        </div>
                                        <div class="is-size-6 left10">slink.com/hits<b>:email</b></div>
                                    </div>

                                    <div class="left20 top15 lpSub">
                                        <div class="columns lpCols">
                                            <div class="isPoppins is-size-4  column is-one-third">&nbsp;<b>:call</b></div>
                                            <div class="is-size-5  column">
                                                <div class="lpDescHome is-size-5"  column>Reach us by phone</div>
                                            </div>
                                        </div>
                                        <div class="is-size-6 left10">slink.com/hits<b>:call</b></div>
                                    </div>

                       
                                </div>
                                <div class="is-size-5 top20">Your <b>SlinkPage</b> can be reached with the subslink <b class="has-text-yell">:links</b> or you can set it as your default slink URL</div>

                                <div class="top20"><span class="has-text-yell"><div class="is-inline-block vAlignTop is-size-4 has-text-yell"><b>4.</b>&nbsp;</div></span><b>A QR code generator</b> that will create printable QR codes showing your slink or subslink below</div>
                            </div>
                        </div>

                    </div>

              <!-- PRICING PLANS -->

                    <div class="is-size-3 has-text-white top160"><img src="@/assets/img/chevronsT.png" width="27" /><b class="left3">Pricing</b></div>
                    <div class="has-text-yell is-size-4 top20"><b>Try 30 days for free</b> (no credit card)</div>
                    <div v-if="$root.showPlans" class="columns top20 mobileMargin pricingBG"  data-aos="fade-left">
                        <div class="column top20">
                            <div class="has-text-centered planPanel">
                                <div class="planTitleHome"><b>• BASIC •</b></div>
                                <div class="top40">
                                    <div class="is-size-3"><b>Slink + <span class="has-text-yell">{{$root.newPlans.SmallYearly.limit}} subslinks</span ></b></div>
                                    <div class="is-size-6 top5"><b>-</b></div>
                                    <div class="is-size-6 top5"><b>SlinkPage</b></div>
                                    <div class="is-size-6 top5"><b>QR codes</b></div>
                                    <div class="is-size-6 top5">2 million redirects per year</div>
                                    <div class="is-size-4 top40 priceContainer">$<b>{{$root.newPlans.SmallMonthly.price}}</b>/mth <br><span class="is-size-6">or</span ><br>$<b>{{$root.newPlans.SmallYearly.price}}</b>/yr</div>
                                    <br>
                                </div>
                            </div>
                        </div>
                        <div class="column top20">
                            <div class="has-text-centered planPanel">
                                <div class="planTitleHome"><b>• PERSONAL •</b></div>
                                <div class="top40">
                                    <div class="is-size-3"><b>Slink + <span class="has-text-yell">{{$root.newPlans.MediumYearly.limit}} subslinks</span></b></div>
                                    <div class="is-size-6 top5"><b>Analytics</b></div>
                                    <div class="is-size-6 top5"><b>SlinkPage</b></div>
                                    <div class="is-size-6 top5"><b>QR codes</b></div>
                                    <div class="is-size-6 top5">3 million redirects per year</div>
                                    <div class="is-size-4 top40 priceContainer">$$<b>{{$root.newPlans.MediumMonthly.price}}</b>/mth <br><span class="is-size-6">or</span ><br>$<b>{{$root.newPlans.MediumYearly.price}}</b>/yr</div>
                                    <br>
                                </div>
                                
                            </div>
                        </div>
                        <div class="column top20">
                            <div class="has-text-centered planPanel">
                                <div class="planTitleHome"><b>• PRO •</b></div>
                                <div class="top40">
                                    <div class="is-size-3"><b>Slink + <span class="has-text-yell">{{$root.newPlans.LargeYearly.limit}} subslinks</span></b></div>
                                    <div class="is-size-6 top5"><b>Analytics</b></div>
                                    <div class="is-size-6 top5"><b>SlinkPage</b></div>
                                    <div class="is-size-6 top5"><b>QR codes</b></div>
                                    <div class="is-size-6 top5">5 million redirects per year</div>
                                    <div class="is-size-4 top40 priceContainer">$$<b>{{$root.newPlans.LargeMonthly.price}}</b>/mth <br><span class="is-size-6">or</span ><br>$<b>{{$root.newPlans.LargeYearly.price}}</b>/yr</div>
                                    <br>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="has-text-white is-size-4 has-text-centered top20"><b>Your account may hold as many Slinks as you like</b></div>
                    <div class="has-text-white is-size-5 has-text-centered top10">*Please contact us for corporate plans with higher subslink counts</div>
                    <br>
                </div>
           </div>

           <!-- USES -->

           <div class="iconsDivContainer" id="uses" ref="uses">
            <div class="container">
                <div class="is-size-2 has-text-petBlue has-text-left top80"><img src="@/assets/img/chevronsY.png" width="30" /><b class="left3">Some use cases</b></div>
                <div class="top20 is-size-5">Slinks have the unique ability to inject meaning into often cryptic URLs.  The combination of a strong slink word and its subslinks, provides a powerful tool to dramatically increase recall, brand recongnition and traffic. Below are some examples of how slinks and subslinks can be used.</div>
                 <div class="columns top60 left10">

                    <div class="column">
                       <div class="pad20">
                            <div class="has-text-yell  top40"><i class="fa fa-bullseye fa-3x"></i></div>
                            <div class="useCard top20">
                                <div class="is-size-4 has-text-petBlue"><b>Make your website more easily accessible</b></div>
                                <div class="top5">Domain names can be difficult to remember and spell. With a slink that describes what your website is about, it will be easy for people to <b>remember how to reach it again and again.</b></div>
                            </div>
                            <div class="top10">
                                For example, the dog rescue organization, "Houston K-911 Rescue", uses the slink:
                            </div>
                            <div class="top10">
                                <img src="@/assets/img/chevronsT.png" width="18"/><span class="is-size-5">slink.com/<b class="has-text-turk">dogrescue</b></span>
                            </div>
                            <div class="top10">
                               to ensure that they stay top-of-mind in people looking for their type of services. <b>Their website can be reached just by remembering what it is about.</b>
                            </div>
                       </div>
                    </div>


                    <div class="column lightBG">
                        <div class="pad20">
                            <div class="has-text-yell  top40"><i class="fa-solid fa-users-gear fa-3x"></i></div>
                            <div class="useCard top20">
                                <div class="is-size-4 has-text-petBlue"><b>Simplify long URLs such as affiliate links</b></div>
                                <div class="top5">If you have a podcast or are an influencer, <b>maximizing the recall of sponsors' calls-to-action and your affiliate links is critical to your bottom line.</b></div>
                            </div>
                            <div class="top10">
                                Affiliate links are an example of notoriously clunky URLs to convey. Using a catalog of subslinks to simplify and organize them provides an effective way for your audience to remember and access them. The following format is very effective:
                            </div>
                            <div class="top10">
                                <img src="@/assets/img/chevronsT.png" width="18"/><span class="is-size-5">slink.com/<b class="has-text-turk">[podcast name]:[brand 1]</b></span><br>
                                <img src="@/assets/img/chevronsT.png" width="18"/><span class="is-size-5">slink.com/<b class="has-text-turk">[podcast name]:[brand 2]</b></span><br>
                                <b class="has-text-turk">...</b>
                            </div>
                        </div>
                       
                    </div>
                 </div>

                 <div class="columns  left10">

                    <div class="column  lightBG">
                        <div class="pad20">
                            <div class="has-text-yell top40"><i class="fa-solid fa-phone-volume fa-3x"></i></div>
                            <div class="useCard top20">
                                <div class="is-size-4 has-text-petBlue"><b>Share contact info effectively</b></div>
                                <div class="top5">Share your telephone number, email address, social media profile or any other contact information <b>using a link that "says" what it does.</b></div>
                            </div>
                            <div class="top10">
                                For example,
                            </div>
                            <div class="top10">
                                <img src="@/assets/img/chevronsT.png" width="18"/><span class="is-size-5">slink.com/<b class="has-text-turk">john:email</b></span><br>
                                <img src="@/assets/img/chevronsT.png" width="18"/><span class="is-size-5">slink.com/<b class="has-text-turk">mycompany:zoom</b></span><br>
                                <img src="@/assets/img/chevronsT.png" width="18"/><span class="is-size-5">slink.com/<b class="has-text-turk">mycompany:paypal</b></span><br>
                                <img src="@/assets/img/chevronsT.png" width="18"/><span class="is-size-5">slink.com/<b class="has-text-turk">insurance:call</b></span><br>
                                <img src="@/assets/img/chevronsT.png" width="18"/><span class="is-size-5">slink.com/<b class="has-text-turk">myliveshow:phone</b></span><br>
                                <img src="@/assets/img/chevronsT.png" width="18"/><span class="is-size-5">slink.com/<b class="has-text-turk">myrestaurant:order</b></span>
                            </div>
                            <div class="top10">
                            Yes, slinks can even point to telephone numbers.
                            </div>
                        </div>
                    </div>


                    <div class="column">
                        <div class="pad20">
                            <div class="has-text-yell  top40"><i class="fa-solid fa-arrows-to-dot fa-3x"></i></div>
                            <div class="useCard top20">
                                <div class="is-size-4 has-text-petBlue"><b>Make your Slink the hub of your operation</b></div>
                                <div class="top5">Many influencers prefer not to have a website, posting all their content on social media platforms.  This can lead to brand fragmentation as the URLs they promote do not share a common domain or structure. Gathering analytics also becomes unwieldly</div>
                            </div>
                            <div class="top10">
                                Using a slink and its subslinks to create a logical, branded catalog of links can be a <b>powerful way to generate more engagement and recognition.</b> Eg:
                            </div>
                            <div class="top10">
                                <img src="@/assets/img/chevronsT.png" width="18"/><span class="is-size-5">slink.com/<b class="has-text-turk">myhandle:featuredpost</b><b></b></span><br>
                                <img src="@/assets/img/chevronsT.png" width="18"/><span class="is-size-5">slink.com/<b class="has-text-turk">myhandle:follow</b><b></b></span><br>
                                <img src="@/assets/img/chevronsT.png" width="18"/><span class="is-size-5">slink.com/<b class="has-text-turk">myhandle:makeup</b><b></b></span><br>
                                <img src="@/assets/img/chevronsT.png" width="18"/><span class="is-size-5">slink.com/<b class="has-text-turk">myhandle:playlist</b><b></b></span><br>
                                <b class="has-text-turk">...</b>
                            </div>
                            <div class="top10">
                                Use the SlinkPage to display them all. You also get analytics for each slink and subslink.
                            </div>
                        </div>
                    
                    </div>
                </div>

                <div class="columns  left10">

                    <div class="column">
                        <div class="pad20">
                            <div class="has-text-yell  top40"><i class="fa-regular fa-lightbulb fa-3x"></i></div>
                            <div class="useCard top20">
                                <div class="is-size-4 has-text-petBlue"><b>Replace awkward QR Codes</b></div>
                                <div class="top5">A QR code must be visible to be useful. Using QR codes in situations where they are only briefly visible, such as in TV commercials is ineffective, especially if the user is actually watching the content on their phone!</div>
                            </div>
                            <div class="top10">
                                Providing either a slink or a slink-generated QR code (which shows the actual slink below the code) is a <b>much more effective way to direct traffic to a URL</b>. The slink will be remembered and can be accessed at any time in the future. Plus, you can change the target URL without having to reprint the QR code. Eg:
                            </div>
                            <div class="top10">
                                <img src="@/assets/img/tutto.png" width="200"/>
                            </div>
                        </div>
                        
        
                    </div>


                    <div class="column  lightBG">
                        <div class="pad20">
                            <div class="has-text-yell  top40"><i class="fa-solid fa-bars fa-3x"></i></div>
                            <div class="useCard top20">
                                <div class="is-size-4 has-text-petBlue"><b>Create a menu of service links</b></div>
                                <div class="top5">Sifting through search engine results is cumbersome and exposes your audience to potential competitors.</div>
                            </div>
                            <div class="top10">
                                With a slink and subslinks you can create logical links for each of the services you offer, <b>once your audience sees or hears them once, they'll remember how to access them.</b> Eg:
                            </div>
                            <div class="top10">
                                <img src="@/assets/img/chevronsT.png" width="18"/><span class="is-size-5">slink.com/<b class="has-text-turk">myrestaurant</b></span><br>
                                <img src="@/assets/img/chevronsT.png" width="18"/><span class="is-size-5">slink.com/<b class="has-text-turk">myrestaurant:menu</b></span><br>
                                <img src="@/assets/img/chevronsT.png" width="18"/><span class="is-size-5">slink.com/<b class="has-text-turk">myrestaurant:order</b></span><br>
                                <img src="@/assets/img/chevronsT.png" width="18"/><span class="is-size-5">slink.com/<b class="has-text-turk">myrestaurant:reservations</b></span><br>
                                <img src="@/assets/img/chevronsT.png" width="18"/><span class="is-size-5">slink.com/<b class="has-text-turk">myrestaurant:location</b></span><br>
                                <b class="has-text-turk">...</b>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           </div>

            <!-- STATS -->


            <div class="stats mobileMargin">
                <div>
                    <div class="">
                        <br>
                       <div class="container leftDotted   top80"  data-aos="fade-right">
                            <div class="left20 ">
                                <br><br><br>
                                
                                <div class="is-size-3 has-text-yell">
                                    <img src="@/assets/img/chevronsT.png" width="30" /><b> Some facts you may already know</b>
                                </div>
                                <div class="is-size-4 top40">
                                    <div class="top20">
                                        The OOH Advertising Industry will reach <b>$26 billion in spending</b>  in 2023
                                    </div>
                                    <div class="top20">
                                        Audio ads is the <b>fastest-growing segment</b> in advertising
                                    </div>

                                    <div class="top20">
                                       +50% of audio ads are  <b>read by the show's host</b> 
                                    </div>
            
                                    <div class="top20">
                                        Digital Audio Advertising spending is projected to reach <b>$8.95 billion</b> in 2023.
                                    </div>
            
                                    <div class="top20">
                                        <b>50% of millennials listen to audio</b> while doing other things like cooking, cleaning, driving and excercising
                                    </div>
                                    <br><br>
                                </div>
            
                                <button class="button is-yell top20 has-text-dark" @click="$router.push('/get')"><b>START SLINKING</b></button>
                            </div>
                            
                       </div>
                     
                    </div>
                </div>
                <br> <br>
            </div>

         
          

           
        </div>
        


    </main-layout>
</template>

<script>

import MainLayout from '../layouts/Main.vue'
import GetStarted from '../components/GetStarted.vue'
import Video1 from '../components/Video1.vue'

export default{
    components: {MainLayout, GetStarted, Video1},
    data: function(){
        return {
            s5: true,
            videoOpen: false,
            vid: null,
            inited: false,
            hash: this.$route.hash
        }

    },
    mounted: function(){

        initTextAnimSlider()
        //var particleCanvas = new ParticleNetwork(document.getElementById('particle-canvas'));
        //this.$root.loadScript('static/slider.js', function(){ return false})
        var self = this
        this.$nextTick(function () {
            if (this.hash) {
                const refName = self.hash.replace('#', '')
                self.scrollToAnchorPoint(refName)
            }
        })
    },

    methods: {
        navToBuy: function () {
        this.$router.push('/get')
        },

        openVideo: function(vid){
            window.scrollTo(0,0)
            this.vid = vid 
            this.videoOpen = true
        },

        closeVideo: function(){
            this.videoOpen = false
        },

        scrollToAnchorPoint(refName) {
            const el = this.$refs[refName]
            el.scrollIntoView({ behavior: 'smooth' })
        },
        goToHow: function(){
            this.$refs.how.scrollIntoView({ behavior: 'smooth' })
        }
    }

   
    
}


</script>

<style scoped>
 .st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}
            .st1{opacity:0.43;}
            .st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000049904097007520743900000005004247079980718244_);}



#dataWords {
  overflow: hidden;
}
#dataWords:after {
  display: none !important;
}

.text-anim-item {
  white-space: nowrap;
  position: absolute;
  left: 0;
  top: 11px;
  -webkit-transform: translate3d(0, -120%, 0);
  transform: translate3d(0, -120%, 0);
  font-weight: bold;
  font-size: 1.5rem;
  color: #ffb227;
  margin-left: 2px;
  padding-left: 7px;
  padding-right: 7px;
  border-radius: 8px
}
.text-anim-item.anim-in {
  -webkit-transform: translate3d(-50%, -120%, 0);
  transform: translate3d(0, -120%, 0);
  -webkit-animation: textAnimInCenter .6s .3s forwards;
  animation: textAnimInCenter .6s .3s forwards;
}
.text-anim-item.anim-out {
  -webkit-transform: translate3d(0, 0%, 0);
  transform: translate3d(0, 0%, 0);
  -webkit-animation: textAnimOutCenter .6s  forwards;
  animation: textAnimOutCenter .6s  forwards;
}
@-webkit-keyframes textAnimIn {
  0% {
    -webkit-transform: translate3d(5%, -120%, 0);
    transform: translate3d(0, -120%, 0);
  }
  100% {
    -webkit-transform: translate3d(0, 8%, 0);
    transform: translate3d(0, 0%, 0);
  }
}
@keyframes textAnimIn {
  0% {
    -webkit-transform: translate3d(0, -120%, 0);
    transform: translate3d(0, -120%, 0);
  }
  100% {
    -webkit-transform: translate3d(0, 0%, 0);
    transform: translate3d(0, 0%, 0);
  }
}
@-webkit-keyframes textAnimOut {
  0% {
    -webkit-transform: translate3d(0, 0%, 0);
    transform: translate3d(0, 0%, 0);
  }
  50% {
    -webkit-transform: translate3d(0, -20%, 0);
    transform: translate3d(0, -20%, 0);
  }
  100% {
    -webkit-transform: translate3d(0, 120%, 0);
    transform: translate3d(0, 120%, 0);
  }
}
@keyframes textAnimOut {
  0% {
    -webkit-transform: translate3d(0, 0%, 0);
    transform: translate3d(0, 0%, 0);
  }
  50% {
    -webkit-transform: translate3d(0, -20%, 0);
    transform: translate3d(0, -20%, 0);
  }
  100% {
    -webkit-transform: translate3d(0, 120%, 0);
    transform: translate3d(0, 120%, 0);
  }
}
@-webkit-keyframes textAnimInCenter {
  0% {
    -webkit-transform: translate3d(0, -120%, 0);
    transform: translate3d(0, -120%, 0);
  }
  100% {
    -webkit-transform: translate3d(0, 10%, 0);
    transform: translate3d(0, 10%, 0);
  }
}
@keyframes textAnimInCenter {
  0% {
    -webkit-transform: translate3d(0, -120%, 0);
    transform: translate3d(0, -120%, 0);
  }
  100% {
    -webkit-transform: translate3d(0, 10%, 0);
    transform: translate3d(0, 10%, 0);
  }
}
@-webkit-keyframes textAnimOutCenter {
  0% {
    -webkit-transform: translate3d(0, 0%, 0);
    transform: translate3d(0, 0%, 0);
  }
  50% {
    -webkit-transform: translate3d(0, -20%, 0);
    transform: translate3d(0, -20%, 0);
  }
  100% {
    -webkit-transform: translate3d(0, 120%, 0);
    transform: translate3d(0, 120%, 0);
  }
}
@keyframes textAnimOutCenter {
  0% {
    -webkit-transform: translate3d(0%, 0%, 0);
    transform: translate3d(0, 0%, 0);
  }
  50% {
    -webkit-transform: translate3d(0, -20%, 0);
    transform: translate3d(0, -20%, 0);
  }
  100% {
    -webkit-transform: translate3d(0, 120%, 0);
    transform: translate3d(0, 120%, 0);
  }
}

/* .anim-line {
  left: auto;
}
.anim-line {
  position: absolute;
  width: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 8px;
  margin: 0 auto;
  border-radius: 5px;
  background: #ee7000;
  -webkit-transition: opacity .3s linear, width .3s .4s;
  transition: opacity .3s linear, width .3s .4s;
}
.anim-line.line-active {
  opacity: 1;
} */
</style>


// WEBPACK FOOTER //
// src/pages/Home.vue